@defer (when pageContent$ | async){
    @if (pageContent$ | async; as page)
    {
    <h1 [innerHTML]="page.title"></h1>
    <div class="mb-3" [innerHTML]="page.content"></div>
    }
}
@placeholder { 
    <app-loading />
}
